import styled from "styled-components";
import FeaturePipeline from "../components/FeaturePipeline";
import { RoundedButton } from "../components/RoundedButton";

import { routes } from "../routes";

const ContentSection = styled.div`
    width: 100%;
    max-width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    margin-top: 2rem;
    padding: 0 1rem;
    box-sizing: border-box;

    a
    {
        padding-left: 48px;
        padding-right: 48px;
    }

    h1
    {
        font-size: clamp(1.75rem, 5vw + 1.5rem, var(--size-title));
        max-width: 19ch;
        width: 100%;
        margin: 0;
        line-height: 1.2;
    }

    p
    {
        font-size: clamp(1rem, 2vw + 0.75rem, var(--size-main));
        color: var(--color-primary);
        font-weight: 200;
        line-height: 1.5;
        width: 100%;
        max-width: 42em;
        margin: 2.5rem 1rem;
    }

    @media (max-width: 768px) {
        margin-top: 2rem;
        padding: 0 1rem;

        a {
            padding-left: 32px;
            padding-right: 32px;
        }

        p {
            margin: 1.5rem 0.5rem;
        }
    }

    @media (max-width: 480px) {
        margin-top: 1.5rem;

        a {
            padding-left: 24px;
            padding-right: 24px;
        }
    }
`;

const Home = () => {
  return (
    <ContentSection>
      <h1>Unified Metadata for Software and Datasets</h1>
      <p>
        Generate comprehensive, and clear metadata for your datasets and
        software using DataDesc to automate data profiling, documentation, and
        integration.
      </p>
      <RoundedButton to={routes.dashboard}>Get Started</RoundedButton>

      <FeaturePipeline />
    </ContentSection>
  );
};

export default Home;
